import { useMemo } from "react";

/**
 * Filter + summary stats for AdminVisitors.
 * Returns { filtered, stats } so the page component just renders.
 */
export default function useVisitorFilters(visitors, q, roleFilter) {
    const filtered = useMemo(() => {
        const needle = q.trim().toLowerCase();
        return visitors.filter((v) => {
            if (roleFilter === "named") {
                if (!v.name) return false;
            } else if (roleFilter !== "all") {
                if (v.role !== roleFilter) return false;
            }
            if (!needle) return true;
            return (
                (v.name && v.name.toLowerCase().includes(needle)) ||
                (v.role && v.role.toLowerCase().includes(needle)) ||
                (v.session_id && v.session_id.toLowerCase().includes(needle))
            );
        });
    }, [visitors, q, roleFilter]);

    const stats = useMemo(() => {
        const total = visitors.length;
        const named = visitors.filter((v) => v.name).length;
        const messages = visitors.reduce((sum, v) => sum + (v.message_count || 0), 0);
        const sevenDaysMs = 7 * 24 * 60 * 60 * 1000;
        const last7 = visitors.filter((v) => {
            if (!v.last_seen) return false;
            return Date.now() - new Date(v.last_seen).getTime() < sevenDaysMs;
        }).length;
        return { total, named, messages, last7 };
    }, [visitors]);

    return { filtered, stats };
}
